/* eslint-disable react/prop-types */
import styled from '@emotion/styled';
import TestSeriesThumbnail from '@base/TestSeriesThumbnail/TestSeriesThumbnail';
import PreviewButton from '@comp/PreviewButton/PreviewButton';
import PlayCircleBig from '@icon/PlayCircleBig';
import Thumbnail from '@base/Thumbnail/Thumbnail';
import H7 from '@base/H7/H7';
import { Spacings } from '@styles/index';
import { getIntroVideoURL } from '@utils/textHelper';

const StyledThumbnail = styled(Thumbnail)`
  height: 180px;
  width: 320px;
  margin-right: ${Spacings.SPACING_8B};
  border-radius: ${Spacings.SPACING_2B};
  transition: all 300ms ease-in-out;
  @media (max-width: 47.95em) {
    width: 100%;
    margin: 0;
  }
`;

const Intro = styled.iframe`
  height: 180px;
  width: 320px;
  border-radius: ${Spacings.SPACING_2B};
  margin-right: ${Spacings.SPACING_8B};
  background-color: var(--color-text-primary);
  @media (max-width: 47.95em) {
    width: 100%;
  }
`;

const TestThumbnail = styled.div`
  margin-right: ${Spacings.SPACING_8B};
  @media (max-width: 47.95em) {
    width: 100%;
  }
`;

const Preview = styled(H7)`
  margin-left: ${Spacings.SPACING_2B};
`;

const CourseThumbnail = ({
  course,
  preview,
  showIntro,
  isTestSeries,
  goalData
}) => {
  if (isTestSeries && !course.thumbnail)
    return (
      <TestThumbnail>
        <TestSeriesThumbnail color={goalData.colorCode} />
      </TestThumbnail>
    );
  if (preview)
    return (
      <Intro
        title="intro"
        src={getIntroVideoURL(course.previewVideo)}
        frameBorder="0"
        allow="autoplay; encrypted-media"
        allowFullScreen="allowFullScreen"
      />
    );
  return (
    <StyledThumbnail
      priority
      imgUrl={course.newThumbnail || course.thumbnail}
      width={320}
      height={180}
      layout="intrinsic"
    >
      {course.previewVideo ? (
        <PreviewButton onClick={showIntro}>
          <PlayCircleBig
            size={Spacings.SPACING_5B}
            color="var(--color-i-white)"
          />
          <Preview color="var(--color-i-white)">PREVIEW</Preview>
        </PreviewButton>
      ) : null}
    </StyledThumbnail>
  );
};

export default CourseThumbnail;
